.ck{outline:none;}